var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plug-tree"},[_c('div',{staticStyle:{"overflow":"auto","height":"calc(100% - 40px)"}},[_c('el-tree',{ref:"nodeTree",attrs:{"props":_vm.props,"highlight-current":true,"current-node-key":_vm.nodeId,"node-key":"id","load":_vm.loadNode,"lazy":""},on:{"node-click":_vm.nodeClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }